import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-sidebar-mobile-header',
  templateUrl: './sidebar-mobile-header.component.html',
  styleUrls: ['./sidebar-mobile-header.component.scss'],
  standalone: false
})
export class SidebarMobileHeaderComponent implements OnInit {
  @Output() sidebarToggle = new EventEmitter<void>();
  logoUrl: string;
  tenantName: string;
  userName: string = '';

  constructor(
    private appConfigService: AppConfigService,
    private oidcSecurityService: OidcSecurityService
  ) {}

  ngOnInit() {
    this.logoUrl = this.appConfigService.tenant.logoUrl;
    this.tenantName = this.appConfigService.tenant.name;
    this.oidcSecurityService.getUserData().subscribe((userData) => {
      this.userName = userData ? `${userData.given_name} ${userData.family_name}` : '';
    });
  }

  onToggle() {
    this.sidebarToggle.emit();
  }

  logout() {
    this.oidcSecurityService.logoffAndRevokeTokens().subscribe(() => {
      this.oidcSecurityService.logoffLocal();
    });
  }

  changePassword() {
    this.oidcSecurityService.getConfiguration().subscribe((config) => {
      if (config) {
        const { authority, postLogoutRedirectUri } = config;
        const returnUrl = `${postLogoutRedirectUri}/dashboard`;
        window.location.href = `${authority}/Account/ChangePassword?returnUrl=${returnUrl}`;
      }
    });
  }
}
